import { useTranslation } from 'react-i18next';

import {
    ContainerInner,
    ContainerSection,
} from '@components/_global/GlobalStyle/Global.styled';
import { Container } from '@components/ions/layouts';
import { DefaultLayout } from '@components/templates/DefaultLayout/DefaultLayout';

import {
    DownloadCaseContentWrapper,
    StyledText,
    StyledTitle,
} from '@domains/download-case-pdf/DownloadCaseContent.styled';
import { CasePinForm } from '@domains/download-case-pdf/organisms/CasePinForm/CasePinForm';

export const DownloadCaseContentAccessPage = () => {
    const { t } = useTranslation();

    return (
        <DefaultLayout>
            <Container>
                <ContainerInner>
                    <ContainerSection>
                        <DownloadCaseContentWrapper>
                            <StyledTitle>
                                {t('DOWNLOAD_CASE_CONTENT_TITLE')}
                            </StyledTitle>
                            <StyledText>
                                {t('DOWNLOAD_CASE_CONTENT_SUBTITLE_1')}
                            </StyledText>
                            <CasePinForm />
                        </DownloadCaseContentWrapper>
                    </ContainerSection>
                </ContainerInner>
            </Container>
        </DefaultLayout>
    );
};
